import React from "react";

function DigitalWalletCalendarIcon({ stroke = "#98A2B3" }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 1.5V4.5"
        stroke={stroke}
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M12 1.5V4.5"
        stroke={stroke}
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M2.625 6.375H15.375"
        stroke={stroke}
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V14.25C2.25 15.0784 2.92157 15.75 3.75 15.75H14.25C15.0784 15.75 15.75 15.0784 15.75 14.25V4.5C15.75 3.67157 15.0784 3 14.25 3Z"
        stroke={stroke}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DigitalWalletCalendarIcon;
